import useAxios from '../../utils/useAxios'
import { createAsyncThunk } from '@reduxjs/toolkit'

export const getMetalDoors = createAsyncThunk('metalDoors/get', async (...args) => {
  try {
    const axios = useAxios()
    const { data } = await axios.get('/api/metaldoors/')
    return data
  } catch (error) {
    const { rejectWithValue } = args[1]
    // return custom error message from API if any
    if (error.response && error.response.data.detail) {
      return rejectWithValue(error.response.data.detail)
    } else {
      return rejectWithValue(error.message)
    }
  }
})

export const saveMetalDoor = createAsyncThunk(
  'metalDoor/save',
  async (metalDoor, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.put(`/api/metaldoors/${metalDoor.id}/`, metalDoor)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const createMetalDoor = createAsyncThunk(
  'metalDoor/create',
  async (metalDoor, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.post('/api/metaldoors/', metalDoor)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)

export const deleteMetalDoor = createAsyncThunk(
  'metalDoor/delete',
  async (metalDoor, { rejectWithValue }) => {
    try {
      const axios = useAxios()
      const { data } = await axios.delete(`/api/metaldoors/${metalDoor.id}/`)
      return data
    } catch (error) {
      // return custom error message from API if any
      if (error.response && error.response.data.detail) {
        return rejectWithValue(error.response.data.detail)
      } else {
        return rejectWithValue(error.message)
      }
    }
  },
)
